import { HttpParams } from "@angular/common/http";

export class ErrorHttpParams extends HttpParams {
    constructor(public ignoreException: boolean) {
     super();
    }
  }